import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';

export type ThemeMode = 'light' | 'dark';

export function createAppTheme(mode: ThemeMode = 'light') {
  const palette = mode === 'light' ? lightPalette : darkPalette;

  let theme = createTheme({
    palette: {
      mode,
      ...palette,
    },
    typography,
    breakpoints,
    shape: {
      borderRadius: 8,
    },
    components,
  });

  theme = responsiveFontSizes(theme);

  return theme;
}

// Re-export theme utilities for easy access
export { gradients, gradientTextSx, gradientBorderSx } from './gradients';
export { glass, glassSx } from './glassmorphism';
export { haptics, hapticSx } from './haptics';
export {
  fadeIn,
  fadeInUp,
  slideInLeft,
  scaleIn,
  shimmer,
  glowPulse,
  durations,
  easings,
} from './animations';
export { glowShadows } from './shadows';
export { brand, neutrals } from './palette';
